import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

interface BlogPostType {
    id: number;
    title: string;
    content: string;
    created_at: string;
}

const BlogPost = () => {
    const { id } = useParams<{ id: string }>(); // Adresten ID'yi string olarak çeker
    const [post, setPost] = useState<BlogPostType | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPost();
    }, [id]);

    const fetchPost = async () => {
        if (!id) {
            setLoading(false);
            return;
        }

        // HATA DÜZELTME: String ID'yi Supabase'in istediği Integer'a çeviriyoruz
        const postId = parseInt(id, 10);
        if (isNaN(postId)) { // Sayı değilse (URL'de metin varsa)
            setLoading(false);
            return;
        }

        try {
            const { data, error } = await supabase
                .from('blogs')
                .select('*')
                .eq('id', postId) // Artık Integer postId kullanılıyor
                .single();

            if (error) throw error;
            setPost(data);
        } catch (error) {
            console.error("Detay yazısı yüklenirken hata:", error);
            setPost(null);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="text-center pt-40">Yükleniyor...</div>;

    // ID geldiği halde veri çekilemezse bu hata gösterilir.
    if (!post)
        return (
            <div className="min-h-screen pt-40 text-center">
                <h1 className="text-4xl text-red-600 font-bold">Yazı Bulunamadı.</h1>
                <p className="text-gray-500 mt-4">Belirtilen ID'ye ait içerik mevcut değil veya silinmiş.</p>
            </div>
        );

    return (
        <div className="min-h-screen bg-background pt-40 pb-16">
            <div className="container mx-auto px-4 max-w-4xl">
                <div className="mb-6 text-sm text-gray-500">
                    {new Date(post.created_at).toLocaleString('tr-TR', {
                        timeZone: 'Europe/Istanbul',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    })}
                </div>
                <h1 className="text-5xl font-extrabold mb-8 text-text-primary">
                    {post.title}
                </h1>

                {/* GÜNCELLENEN KISIM: whitespace-pre-wrap eklendi */}
                <div className="prose max-w-none text-lg text-gray-700 leading-relaxed whitespace-pre-wrap">
                    {post.content}
                </div>

                <button
                    onClick={() => window.history.back()}
                    className="mt-12 text-brand-primary hover:underline font-semibold"
                >
                    &larr; Tüm Yazılara Geri Dön
                </button>
            </div>
        </div>
    );
};

export default BlogPost;